export default function StatsBar() {
  const stats = [
    {
      icon: 'ri-star-fill',
      value: '4.9/5',
      label: 'Klantbeoordeling',
    },
    {
      icon: 'ri-shield-check-line',
      value: '20+ jaar',
      label: 'Ervaring',
    },
    {
      icon: 'ri-team-line',
      value: '2.400+',
      label: 'Tevreden klanten',
    },
    {
      icon: 'ri-award-line',
      value: '10 jaar',
      label: 'Garantie',
    },
  ];

  return (
    <section className="py-10 sm:py-14 bg-cream-50 border-y border-brass-500/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 lg:gap-12">
          {stats.map((stat, i) => (
            <div key={i} className="flex flex-col items-center text-center group">
              <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center rounded-2xl bg-brass-500/10 mb-3 sm:mb-4 group-hover:bg-brass-500/20 transition-colors">
                <i className={`${stat.icon} text-xl sm:text-2xl text-brass-500`}></i>
              </div>
              <div className="font-semibold text-xl sm:text-2xl lg:text-3xl text-ink-900 mb-0.5">{stat.value}</div>
              <div className="text-sm sm:text-base text-ink-600">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}